<template>
  <main class="page apply-page">
    <div class="apply-page__container">
      <ul class="breadcrumbs">
        <li class="breadcrumbs__item">
          <router-link :to="{ name: 'home'}">Главная</router-link>
        </li>
        <li class="breadcrumbs__item">
          <span>Электронная приемная</span>
        </li>
      </ul>
      <h1 class="apply-page__title">Электронная приемная</h1>
      <form @submit.prevent="findAppeal" class="document-page__search">
        <i aria-hidden="true" class="document-page__search__icon">
          <search-icon/>
        </i>
        <input autocomplete="off" class="document-page__search__input" placeholder="Поиск обращения по ID" title="Поиск обращения по ID" type="text" v-model="search"/>
        <button type="submit" class="button" style="margin-left: 24px">Искать</button>
      </form>
      <div class="news-page__article--wide" v-if="appeal_info">
        <h1 class="news-page__title">{{ appeal_result_title }}</h1>
        <div class="news-page__content">
          <p v-if="appeal_name !== null">
            <span>ФИО:</span>
            {{appeal_name}}
          </p>
          <p v-if="appeal_status !== null">
            <span>Статус:</span>
            {{appeal_status}}
          </p>
          <p v-if="appeal_id !== null">
            <span>ID:</span>
            {{appeal_id}}
          </p>
          <p v-if="appeal_date !== null">
            <span>Дата:</span>
            {{appeal_date}}
          </p>
          <p v-if="appeal_text !== null">
            <span>Текст:</span>
            {{appeal_text}}
          </p>
          <p v-if="appeal_comment !== null">
            <span>Комментарий управления:</span>
            {{appeal_comment}}
          </p>
        </div>
      </div>
      <h2 class="apply-page__header">Укажите ваши данные и задайте вопрос</h2>
      <div class="apply-page__content">
        <form class="apply-page__form" @submit.prevent="submit">
          <div class="row apply-page__form__toggle">
            <div class="col-2">
              <button type="button" class="button-light" :class="{'active': type_id === 21}" @click="type_id = 21">Для физических лиц</button>
            </div>
            <div class="col-2">
              <button type="button" class="button-light" :class="{'active': type_id === 22}" @click="type_id = 22">Для юридических лиц</button>
            </div>
          </div>
          <div class="row">
            <div class="col-1">
              <select class="input" title="Тип обращения" v-model="appeal_type" required>
                <option :value="null" selected disabled>Выберите тип обращения *</option>
                <option v-for="(appeal, index) in $store.state.appeals" :key="index" :value="appeal.id">{{ appeal.name }}</option>
              </select>
            </div>
          </div>
          <div class="row">
            <div class="col-1">
              <select class="input" title="Получатель" v-model="recipient" required>
                <option :value="null" selected disabled>Выберите получателя *</option>
                <option value="начальник" name="">Обращение к руководителю</option>
              </select>
            </div>
          </div>
          <div class="row">
            <div class="col-3">
              <input type="text" class="input" name="surname" title="Иванов" placeholder="Фамилия*" pattern="^[a-zA-Zа-яА-Я-]{2,25}" required v-model="surname"/>
            </div>
            <div class="col-3">
              <input type="text" class="input" name="name" title="Андрей" placeholder="Имя*" pattern="^[a-zA-Zа-яА-Я-]{2,25}" required v-model="name"/>
            </div>
            <div class="col-3">
              <input type="text" class="input" name="patronymic" title="Иванович" placeholder="Отчество*" pattern="^[a-zA-Zа-яА-Я-]{2,25}" required v-model="patronymic"/>
            </div>
          </div>
          <div class="row" v-if="type_id === 22">
            <div class="col-1">
              <input type="text" class="input" name="company_name" title="ООО Каспий*" placeholder="Название организации*" pattern="^[a-zA-Zа-яА-Я0-9 -]{2,40}" required v-model="company_name"/>
            </div>
          </div>
          <div class="row">
            <div class="col-2">
              <input type="text" class="input" name="email" title="example@mail.com" placeholder="Email*" inputmode="email" pattern="^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]{2,})*$" required v-model="email"/>
            </div>
            <div class="col-2">
              <input type="text" class="input" name="phone" title="+70123456789" placeholder="Телефон*" inputmode="tel" pattern="^\+7{1}\d{3}\d{3}\d{2}\d{2}$" required v-model="tel"/>
            </div>
          </div>
          <div class="row">
            <div class="col-3">
              <input type="text" class="input" name="city" title="Москва" placeholder="Город" pattern="^[a-zA-Zа-яА-Я ]{2,30}" v-model="city"/>
            </div>
            <div class="col-3">
              <input type="text" class="input" name="street" title="Шамиля" placeholder="Улица" pattern="^[a-zA-Zа-яА-Я0-9 -]{2,30}" v-model="street"/>
            </div>
            <div class="col-3">
              <input type="text" class="input" name="home" title="51" placeholder="Дом" pattern="^[0-9]{1,4}" v-model="home"/>
            </div>
            <div class="col-3">
              <input type="text" class="input" name="building" title="6" placeholder="Строение" pattern="^[0-9]{1,3}" v-model="structure"/>
            </div>
            <div class="col-3">
              <input type="text" class="input" name="corps" title="А" placeholder="Корпус" pattern="^[a-zA-Zа-яА-Я]{1,3}" v-model="corps"/>
            </div>
            <div class="col-3">
              <input type="text" class="input" name="flat" title="21" placeholder="Квартира" pattern="^[0-9]{1,3}" v-model="flat"/>
            </div>
            <div class="col-3">
              <input type="text" class="input" name="index" title="367000" placeholder="Индекс" pattern="^[0-9]{6}" v-model="index"/>
            </div>
          </div>
          <div class="row">
            <div class="col-1">
              <textarea name="question_title" placeholder="Суть вопроса*" class="input" title="Суть вопроса*" required v-model="question_title"></textarea>
            </div>
          </div>
          <div class="row">
            <div class="col-1">
              <textarea name="question" placeholder="Содержание обращения*" class="input" title="Содержание обращения*" required v-model="question"></textarea>
            </div>
          </div>
          <div class="row">
            <div class="col-1">
              <textarea name="before_question" class="input" title="В какие органы государственной власти вы обращались и когда" placeholder="В какие органы государственной власти вы обращались и когда" v-model="before_question"></textarea>
            </div>
          </div>
          <div class="apply-page__form__footer">
            <button type="button" class="button-light" @click="$refs.files.click()">
              <i aria-hidden="true">
                <append-file-icon/>
              </i>
              <span>{{ fileTitle }}</span>
            </button>
            <button type="submit" class="button">Отправить</button>
          </div>
          <input type="file" name="files" @change="previewFiles" multiple ref="files" style="display: none">
        </form>
        <div class="apply-page__notification">
          <label>Уважаемые пользователи!</label>
          <p>Просим вас внимательно ознакомиться с порядком приёма и рассмотрения обращений в электронном виде.</p>
          <router-link :to="{ name: 'contacts' }">{{ $store.state.api }}/contacts</router-link>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import AppendFileIcon from 'components/svg/AppendFileIcon.vue'
import SearchIcon from 'components/svg/SearchIcon.vue'
import axios from 'axios'

export default {
  name: 'ApplyPage',
  components: {
    SearchIcon,
    AppendFileIcon
  },
  async asyncData ({ store }) {
    await store.dispatch('APPLY_PAGE')
  },
  data () {
    return {
      search: '',
      type_id: 21,
      company_name: '',
      appeal_type: null,
      surname: '',
      name: '',
      patronymic: '',
      recipient: null,
      city: '',
      street: '',
      home: '',
      structure: '',
      corps: '',
      flat: '',
      index: '',
      email: '',
      tel: '',
      question_title: '',
      question: '',
      before_question: '',
      files: [],
      appeal_input: null,
      appeal_info: false,
      appeal_result_title: null,
      appeal_name: null,
      appeal_status: null,
      appeal_id: null,
      appeal_date: null,
      appeal_text: null,
      appeal_comment: null
    }
  },
  computed: {
    fileTitle () {
      return this.files.length > 1 ? 'Выбрано файлов: ' + this.files.length : this.files.length > 0 ? this.files[0].name.length > 17 ? 'Выбран ' + this.files[0].name.slice(0, 17) + '...' : this.files[0].name : 'Прикрепить файлы'
    }
  },
  metaInfo () {
    return this.$seo(
      'common',
      'Электронная приемная',
      'управление образования, образование',
      '',
      'Электронная приемная',
      '',
      ''
    )
  },
  methods: {
    findAppeal (event) {
      this.$Progress.start()
      const fd = new FormData()
      fd.append('appeal_key', this.search)
      axios.post(this.$store.state.api + '/api/appealkey', fd).then(response => {
        if ((Object.keys(response.data)).length !== 0) {
          this.appeal_result_title = 'Результаты поиска обращения:'
          const info = response.data
          this.appeal_name = info.surname + ' ' + info.name + ' ' + info.patronymic
          // не передается
          this.appeal_status = info.status.text
          this.appeal_date = info.created_at
          this.appeal_id = info.appeal_key
          this.appeal_text = info.about_question
          this.appeal_comment = info.comment
          this.appeal_info = true
          this.loading = false
        } else {
          this.appeal_result_title = 'Вы ввели не правильный id обращения.'
          this.appeal_name = this.appeal_status = this.appeal_date = this.appeal_id = this.appeal_text = this.appeal_comment = null
          this.appeal_info = true
        }
        this.$Progress.finish()
      }).catch((error) => {
        console.error(error)
        this.$Progress.fail()
        alert('Произошла ошибка! Попробуйте позднее')
      })
    },
    previewFiles (event) {
      this.files = event.target.files
    },
    submit () {
      this.$Progress.start()
      const fd = new FormData()
      fd.append('types_id', this.type_id)
      if (this.type_id === 22) {
        fd.append('name_organ', this.company_name)
      }
      fd.append('appeal_type', this.appeal_type)
      fd.append('surname', this.surname)
      fd.append('name', this.name)
      fd.append('patronymic', this.patronymic)
      fd.append('recipient', this.recipient)
      fd.append('city', this.city)
      fd.append('street', this.street)
      fd.append('home', this.home)
      fd.append('structure', this.structure)
      fd.append('corps', this.corps)
      fd.append('flat', this.flat)
      fd.append('index', this.index)
      fd.append('email', this.email)
      fd.append('phone', this.tel)
      fd.append('about_question', this.question_title)
      fd.append('content_appeal', this.question)
      fd.append('other_goverment_department', this.before_question)

      for (let i = 0; i < this.files.length; i++) {
        const file = this.files[i]
        fd.append('uploads[' + i + ']', file)
      }

      axios.post(this.$store.state.api + '/api/appeal', fd).then((res) => {
        this.$Progress.finish()
        alert(`Обращение успешно отправлено! Ваш id ${res.data.appeal_key}. Мы подготовим ответ и вышлем его на электронный адрес, оставленный Вами при обращении`)
      }).catch((error) => {
        console.error(error)
        alert('Произошла ошибка! Попробуйте позднее')
        this.$Progress.fail()
      })
    }
  }
}
</script>
